import '../../../../assets/stylesheets/reix-select.css';
import React from 'react';
import { ItemStyling } from '../../../utility/dropdown';

type ReixSelectProps = {
  value: string | number;
  setValue: (value: string | number) => void;
  options: { value: string | number; label: string }[];
};

export const ReixSelect = ({ value, setValue, options }: ReixSelectProps) => {
  return (
    <div className="h-full w-full">
      <select
        name="view-select"
        id="view-select"
        value={value}
        onChange={(e) => {
          const raw = e.target.value;
          const matched = options.find((o) => String(o.value) === raw);
          setValue(matched ? matched.value : raw);
        }}
        className="w-full rounded-lg bg-reix-blue text-white cursor-pointer border-none py-.5 duration-300 truncate"
      >
        {options.map((option) => (
          <option
            key={option.value}
            className={ItemStyling}
            value={option.value}
          >
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};
